<nz-tabset [nzSelectedIndex]="tabIndex">
    <nz-tab nzTitle="商品拆分结果">
        <button class="refresh-button" nz-button
            nzType="primary" (click)="refresh()" [nzLoading]="!isFinished">
            刷新</button>
           
        <nz-collapse>
            @for (result of resultData; track result) {
            <nz-collapse-panel [nzHeader]="result.textItems[0].itemId" [nzActive]="true">
                <div nz-row [nzGutter]="8">
                    <div nz-col nzSpan="20">
                        <nz-col class="trend-title"><b>文本解析结果</b></nz-col>
                        <nz-table [nzFrontPagination]="false" nzShowSizeChanger nzShowQuickJumper
                            [nzPageSize]="pageSize" nzTableLayout="fixed" #tableData [nzSize]="'small'"
                            [nzData]="result.textItems" [nzLoading]="isLoading$ | async" [nzScroll]="{ y: '500px' }"
                            [nzShowPagination]="false">
                            <thead>
                                <tr>
                                    <th *ngFor="let column of columns" [nzColumnKey]="column.key"
                                        [nzAlign]="column.align === 'right' ? 'right' : column.align === 'center' ? 'center' : 'left'"
                                        [nzWidth]="column.width || null">
                                        {{ column.title }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let rowdata of tableData.data">
                                    <td *ngFor="let column of columns" [nzEllipsis]="column.ellipsis"
                                        [nzAlign]="column.align === 'right' ? 'right' : column.align === 'center' ? 'center' : 'left'">
                                        <ng-container [ngSwitch]="column.key">
                                            <a *ngSwitchCase="'prodId'" class="prod-link active"
                                                [href]="rowdata.prodLink" target="_blank">{{
                                                rowdata[column.key] }}</a>
                                            <span *ngSwitchCase="'prodName'" nz-tooltip
                                                [nzTooltipTitle]="rowdata.result">{{
                                                rowdata[column.key]
                                                }}</span>
                                            <span *ngSwitchDefault>{{ rowdata[column.key] }}</span>
                                        </ng-container>
                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>
                    </div>
                    <div nz-col nzSpan="4"></div>
                </div>
                <div nz-row [nzGutter]="8" *ngIf="result && result.imageItems && result.imageItems.length">
                    <div nz-col nzSpan="20">
                        <nz-col class="trend-title"><b>图片解析结果</b></nz-col>
                        <nz-table [nzFrontPagination]="false" nzShowSizeChanger nzShowQuickJumper
                            [nzPageSize]="pageSize" nzTableLayout="fixed" #tableData [nzSize]="'small'"
                            [nzData]="result.imageItems" [nzLoading]="isLoading$ | async" [nzScroll]="{ y: '500px' }"
                            [nzShowPagination]="false">
                            <thead>
                                <tr>
                                    <th *ngFor="let column of columns" [nzColumnKey]="column.key"
                                        [nzAlign]="column.align === 'right' ? 'right' : column.align === 'center' ? 'center' : 'left'"
                                        [nzWidth]="column.width || null">
                                        {{ column.title }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let rowdata of tableData.data">
                                    <td *ngFor="let column of columns" [nzEllipsis]="column.ellipsis"
                                        [nzAlign]="column.align === 'right' ? 'right' : column.align === 'center' ? 'center' : 'left'">
                                        <ng-container [ngSwitch]="column.key">
                                            <a *ngSwitchCase="'prodId'" class="prod-link active"
                                                [href]="rowdata.prodLink" target="_blank">{{
                                                rowdata[column.key] }}</a>
                                            <span *ngSwitchCase="'prodName'" nz-tooltip
                                                [nzTooltipTitle]="rowdata.result">{{
                                                rowdata[column.key]
                                                }}</span>
                                            <span *ngSwitchDefault>{{ rowdata[column.key] }}</span>
                                        </ng-container>
                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>
                    </div>
                    <div nz-col nzSpan="4" *ngIf="result.imageItems[0].imageLink && result.imageItems[0].imageLink[0]">
                        <img nz-image width="200px" height="200px" class="image-result"
                            [nzSrc]="result.imageItems[0].imageLink[0]"
                            alt="" />
                    </div>
                </div>
            </nz-collapse-panel>
        }
    </nz-collapse>
    </nz-tab>
    <nz-tab nzTitle="拆分结果汇总">
        <button class="refresh-button" nz-button nzType="primary" (click)="refreshSummary()" [nzLoading]="!isFinished">刷新</button>
        <div nz-row [nzGutter]="8" >
            <div nz-col nzSpan="12" *ngFor="let category of summaryResultData | appProperties">
                <nz-col class="trend-title"><b>{{ category }}: {{ summaryResultData[category].length }}
                        Records</b></nz-col>
                <nz-table [nzFrontPagination]="false" nzShowSizeChanger nzShowQuickJumper [nzPageSize]="pageSize"
                    nzTableLayout="fixed" #summarytableData [nzSize]="'small'" [nzData]="summaryResultData[category]"
                    [nzLoading]="isLoading$ | async" [nzScroll]="{ y: '500px' }">
                    <thead>
                        <tr>
                            <th *ngFor="let column of summaryColumns" [nzColumnKey]="column.key"
                                [nzAlign]="column.align === 'right' ? 'right' : column.align === 'center' ? 'center' : 'left'"
                                [nzWidth]="column.width || null">
                                {{ column.title }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let rowdata of summarytableData.data">
                            <td *ngFor="let column of summaryColumns" [nzEllipsis]="column.ellipsis"
                                [nzAlign]="column.align === 'right' ? 'right' : column.align === 'center' ? 'center' : 'left'">
                                <ng-container [ngSwitch]="column.key">
                                    <a *ngSwitchCase="'prodId'" class="prod-link active" [href]="rowdata.prodLink"
                                        target="_blank">{{ rowdata[column.key] }}</a>
                                    <span *ngSwitchCase="'prodName'" nz-tooltip [nzTooltipTitle]="rowdata.result">{{
                                        rowdata[column.key] }}</span>
                                    <span *ngSwitchDefault>{{ rowdata[column.key] }}</span>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </nz-tab>
</nz-tabset>